<template>
  <div id="keycard-new-view">
    <div class="flex-grow">
      <div class="contenidor">
        <dl>
          <dt>
            <inline-svg class="icon" src="/img/icons/icon-radio-active.svg" />
            <p class="text">{{ $t('participants.keycard.pickup') }}</p>
            <p class="price">{{ keycardPriceWithCurrency }}</p>
          </dt>
          <dd class="explanation">
            {{ $t('participants.keycard.pickupdesc') }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="bottom sticky-bottom">
      <ria-button class="uppercase" :text="$t('participants.confirm')" :fullwidth="true" :action="confirmKeyCardOption"/>
    </div>
  </div>

</template>

<script>
  import RiaButton from "../components/common/ria-button";
  import { mapGetters, mapActions } from 'vuex';
  import {keepScroll} from "../mixins";

  export default {
    name: "KeycardNew",
    mixins: [keepScroll],
    components: {
      RiaButton
    },
    data() {
      return {
        keycard_price: ''
      }
    },
    computed: {
      ...mapGetters('order', ["details"]),
      ...mapGetters('resort', ["resort", "selectedCatalog"]),
      ...mapGetters('prices', ["keycardPrice"]),
      keycardPriceWithCurrency() {
        return typeof this.keycard_price === 'number' ? `+${this.$options.filters.money(this.keycard_price)}` : '';
      }
    },
    methods: {
      ...mapActions("prices", ["loadKeycard"]),
      confirmKeyCardOption: function() {
          const keycardNumber = this.details[this.$route.params.participantIndex].keycard.number;
          if (keycardNumber !== undefined) {
            this.$store.commit('customer/SET_KEYCARD_SELECTION', { number: keycardNumber, unselected: true });
          }
          this.$store.commit('order/SET_DETAIL_FIELD', {
            index: parseInt(this.$route.params.participantIndex),
            field: 'keycard',
            value: { new: true }
          })
          this.$router.push({ name: 'Participants' })
      }
    },
    async created() {
      const keycard = this.selectedCatalog.products.find(product => product.type.code === 'keycard');
      if(keycard) {
        await this.loadKeycard({
          keycardid: keycard.id
        });
        this.keycard_price = this.keycardPrice(
          this.details[this.$route.params.participantIndex].date,
          this.details[this.$route.params.participantIndex].participant_id
        );
      }
    }
  };
</script>

<style scoped>
  .contenidor {
    @apply px-5 bg-white;
  }

  dl {
    @apply border-b-1 border-grey-border p-px;
  }

  dl:last-child {
    @apply border-0;
  }

  dt {
    @apply py-4 flex justify-between;
  }

  dd {
    @apply ml-8 mb-8 mt-minus3 text-left text-sm font-light;
  }

  .icon {
    @apply w-6 h-6 object-contain flex-grow-0 mr-2;
  }

  .text {
    @apply text-sm text-black text-left flex-grow;
  }

  .price {
    @apply text-sm text-grey-text text-right flex-grow;
  }

  .explanation {
    @apply text-xs text-grey-text text-left max-w-2/3;
  }

  .bottom {
    @apply w-full py-3.5 px-5 flex justify-between items-center bg-white z-5 border-t-1 border-grey-border;
  }

  #keycard-new-view {
    @apply flex flex-grow flex-col min-h-screen;
  }

  @screen lg {
    #keycard-new-view {
      @apply block min-h-0;
    }

    .bottom {
      @apply relative;
    }
  }

</style>
